import { render } from "./OTP.vue?vue&type=template&id=24c7955d&scoped=true"
import script from "./OTP.vue?vue&type=script&lang=js"
export * from "./OTP.vue?vue&type=script&lang=js"

import "./OTP.vue?vue&type=style&index=0&id=24c7955d&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c7955d"]])

export default __exports__